define(['exports', 'react', 'prop-types', 'lodash', '../../i18n', '../../assets/Logo-vertical.svg', '../common/Field', '../common/Button', '../common/Errors', '../common/PasswordCriteria'], function (exports, _react, _propTypes, _lodash, _i18n, _LogoVertical, _Field, _Button, _Errors, _PasswordCriteria) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _lodash2 = _interopRequireDefault(_lodash);

  var _i18n2 = _interopRequireDefault(_i18n);

  var _LogoVertical2 = _interopRequireDefault(_LogoVertical);

  var _Field2 = _interopRequireDefault(_Field);

  var _Button2 = _interopRequireDefault(_Button);

  var _Errors2 = _interopRequireDefault(_Errors);

  var _PasswordCriteria2 = _interopRequireDefault(_PasswordCriteria);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var ResetPasswordView = function (_Component) {
    _inherits(ResetPasswordView, _Component);

    function ResetPasswordView(props) {
      _classCallCheck(this, ResetPasswordView);

      var _this = _possibleConstructorReturn(this, (ResetPasswordView.__proto__ || Object.getPrototypeOf(ResetPasswordView)).call(this, props));

      _this.state = {
        showErrors: false,
        changedFields: []
      };
      return _this;
    }

    _createClass(ResetPasswordView, [{
      key: 'componentWillMount',
      value: function componentWillMount() {
        var _props = this.props,
            token = _props.token,
            history = _props.history,
            routePath = _props.routePath;

        if (!token) {
          history.push(routePath.resetPasswordRoute);
        }
        this.props.updateNewPassword('');
      }
    }, {
      key: 'handleResetPassword',
      value: function handleResetPassword() {
        var _props2 = this.props,
            token = _props2.token,
            profile = _props2.profile,
            resetPassword = _props2.resetPassword;

        var errors = _lodash2.default.omit(profile.errors.validation, ['old']);
        var hasError = !_lodash2.default.isEmpty(errors);
        if (hasError) {
          this.setState({ showErrors: true });
          return;
        }
        !hasError && resetPassword(token);
      }
    }, {
      key: 'updateChangedFields',
      value: function updateChangedFields(filedName) {
        var changedFields = this.state.changedFields;

        if (!changedFields.includes(filedName)) {
          this.setState({ changedFields: changedFields.concat(filedName) });
        }
      }
    }, {
      key: 'handleUpdateNewPassword',
      value: function handleUpdateNewPassword(password) {
        this.updateChangedFields(_i18n2.default.t('dk-ui-lib.profile.changePassword.newPassword'));
        this.props.updateNewPassword(password);
      }
    }, {
      key: 'handleUpdateConfirmNewPassword',
      value: function handleUpdateConfirmNewPassword(password) {
        this.updateChangedFields(_i18n2.default.t('dk-ui-lib.profile.changePassword.confirmNewPassword'));
        this.props.updateConfirmNewPassword(password);
      }
    }, {
      key: 'renderFields',
      value: function renderFields(fields) {
        var _this2 = this;

        return fields.map(function (_ref) {
          var value = _ref.value,
              label = _ref.label,
              msgs = _ref.msgs,
              onChange = _ref.onChange;

          return _react2.default.createElement(
            'div',
            { className: 'mt2' },
            _react2.default.createElement(_Field2.default, {
              inputType: 'password',
              value: value,
              label: label,
              width: 50,
              onChange: onChange,
              msgs: msgs,
              onEnter: function onEnter() {
                return _this2.handleResetPassword();
              } })
          );
        });
      }
    }, {
      key: 'renderResetPasswordView',
      value: function renderResetPasswordView() {
        var _this3 = this;

        var _props3 = this.props,
            updateNewPassword = _props3.updateNewPassword,
            updateConfirmNewPassword = _props3.updateConfirmNewPassword,
            profile = _props3.profile;
        var password = profile.password,
            errors = profile.errors;
        var newPassword = password.newPassword,
            confirm = password.confirm;
        var _state = this.state,
            showErrors = _state.showErrors,
            changedFields = _state.changedFields;


        var errorsArr = _lodash2.default.compact([errors.password]);

        var shouldShowNewPasswordStatus = showErrors || changedFields.includes(_i18n2.default.t('dk-ui-lib.profile.changePassword.newPassword'));
        var shouldShowConfirmPasswordStatus = showErrors || changedFields.includes(_i18n2.default.t('dk-ui-lib.profile.changePassword.confirmNewPassword'));

        var passwordMismatch = shouldShowConfirmPasswordStatus && errors && errors.validation && errors.validation[''] ? _i18n2.default.t('dk-ui-lib.errors.profile.passwordMismatch').toLowerCase() : null;
        var newPasswordError = shouldShowNewPasswordStatus && errors && errors.validation && errors.validation.newPassword ? _i18n2.default.t('dk-ui-lib.errors.profile.passwordCriteria').toLowerCase() : null;
        var confirmPasswordError = newPasswordError && shouldShowConfirmPasswordStatus && errors && errors.validation && errors.validation.confirm ? _i18n2.default.t('dk-ui-lib.errors.profile.passwordCriteria').toLowerCase() : passwordMismatch;

        // let disableSaveButton = !!(_.isEmpty(_.compact(_.values(password))) ||  passwordMismatch || newPasswordError);

        var fields = [{
          value: newPassword,
          label: _i18n2.default.t('dk-ui-lib.profile.changePassword.newPassword'),
          onChange: function onChange(password) {
            return _this3.handleUpdateNewPassword(password);
          },
          msgs: {
            error: newPasswordError,
            valid: shouldShowNewPasswordStatus && _i18n2.default.t('dk-ui-lib.profile.changePassword.valid.password')
          }
        }, {
          value: confirm,
          label: _i18n2.default.t('dk-ui-lib.profile.changePassword.confirmNewPassword'),
          onChange: function onChange(password) {
            return _this3.handleUpdateConfirmNewPassword(password);
          },
          msgs: {
            error: confirmPasswordError,
            valid: shouldShowConfirmPasswordStatus && _i18n2.default.t('dk-ui-lib.profile.changePassword.valid.match')
          }
        }];

        return _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'div',
            { className: 'pb2' },
            showErrors && !_lodash2.default.isEmpty(errorsArr) && _react2.default.createElement(_Errors2.default, { errors: errorsArr })
          ),
          _react2.default.createElement(
            'div',
            { className: 'h3 bold black mb2' },
            _i18n2.default.t('dk-ui-lib.profile.changePassword.changePassword')
          ),
          _react2.default.createElement(_PasswordCriteria2.default, null),
          _react2.default.createElement(
            'div',
            { className: '' },
            this.renderFields(fields)
          ),
          _react2.default.createElement(
            'div',
            { className: 'flex items-center flex-column mt3' },
            _react2.default.createElement(_Button2.default, {
              type: 'primary',
              label: _i18n2.default.t('dk-ui-lib.profile.changePassword.save'),
              buttonStyle: { padding: '0.7rem' },
              labelStyle: { fontSize: '1rem' }
              // disabled={disableSaveButton}
              , icon: '',
              onClick: function onClick() {
                return _this3.handleResetPassword();
              } })
          )
        );
      }
    }, {
      key: 'render',
      value: function render() {
        var token = this.props.token;

        return _react2.default.createElement(
          'div',
          { className: 'col-6 px4' },
          _react2.default.createElement(
            'div',
            { className: 'mt3 mb1 center' },
            _react2.default.createElement(_LogoVertical2.default, null)
          ),
          _react2.default.createElement(
            'div',
            { level: 1, className: 'p4 mx2 my1 h5 white-background' },
            this.renderResetPasswordView()
          )
        );
      }
    }]);

    return ResetPasswordView;
  }(_react.Component);

  exports.default = ResetPasswordView;


  ResetPasswordView.propTypes = {
    profile: _propTypes2.default.object.isRequired,
    token: _propTypes2.default.string,
    updateEmailInProfile: _propTypes2.default.func.isRequired,
    updateNewPassword: _propTypes2.default.func.isRequired,
    updateConfirmNewPassword: _propTypes2.default.func.isRequired,
    resetPassword: _propTypes2.default.func.isRequired,
    initiateForgetPassword: _propTypes2.default.func.isRequired

  };
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/dk-ui-lib/lib/reset-password/index.js
// module id = 1178
// module chunks = 0